export default __webpack_public_path__ + "static/media/Vista.721ff45b.ttf";